import { styled } from '@mui/system'
import { colors, fontSizes } from '../consts'
import { Img } from '../Image/Img'

export const Container = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: 'calc(100vh - 70px)',
  background: 'rgba(0,0,0,0.2)',
  zIndex: 9001,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    height: 'calc(100vh - 60px)',
  },
}))

export const MessageBox = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  background: colors.white,
  borderRadius: 8,
  boxShadow: '0 2px 16px rgba(0,0,0,0.2)',
  maxWidth: 400,
  width: '100%',
  padding: 24,
  outline: 0,
}))

export const Header = styled('h2')(({ theme }) => ({
  margin: 0,
  marginBottom: 12,
  fontSize: fontSizes.medium,
  fontWeight: 600,
  textAlign: 'center',
  color: colors.gray.gray90,
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.small,
  },
}))

export const Message = styled('div')(({ theme }) => ({
  fontSize: fontSizes.small,
  color: colors.gray.gray90,
  marginBottom: 16,
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.xSmall,
  },
}))

export const Image = styled(Img)(({ theme }) => ({
  maxWidth: '100%',
  maxHeight: 120,
  marginBottom: 16,
  borderRadius: 4,
  [theme.breakpoints.down('sm')]: {
    maxHeight: 80,
  },
}))

export const ButtonRow = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 12,
  marginTop: 12,
  width: '100%',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}))

type ActionButtonProps = {
  $bgColor?: string
  $textColor?: string
}
export const ActionButton = styled('button')<ActionButtonProps>(({ theme, $bgColor, $textColor }) => ({
  padding: theme.spacing(1, 2),
  border: 'none',
  borderRadius: 4,
  background: $bgColor ?? colors.yellow,
  color: $textColor ?? colors.white,
  fontWeight: 500,
  fontSize: 15,
  cursor: 'pointer',
  transition: 'background 0.2s',
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.xSmall,
  },
  '&:hover, &:focus': {
    background: $bgColor ?? colors.gold,
  },
}))


export const CloseButton = styled('button')<ActionButtonProps>(({ theme, $bgColor, $textColor }) => ({
  position: 'absolute',
  top: 12,
  right: 12,
  background: $bgColor ?? 'transparent',
  border: 'none',
  fontSize: fontSizes.small,
  color: $textColor ?? colors.gray.gray40,
  cursor: 'pointer',
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.xSmall,
  },
}))
